import React from 'react';
import { Alert } from 'react-bootstrap';

export default function Personalized() {
  return (
    <div className="dark-outlet-background">
      <h1 className="mb-5">PERSONALIZADO</h1>
      <Alert variant="info">
        Esta área está em construção. Em breve você poderá montar estudos
        personalizados do Windx por aqui.
      </Alert>
    </div>
  );
}
